import { observer } from "mobx-react-lite";
import { withT } from "./tools";
import { PirmaryBtn } from "./components/primaryBtn";
import currencyPng from './imgs/currency.png';
import { Twitter } from "./imgs/twitter";
import { Telegram } from "./imgs/telegram";
import { Mail } from "./imgs/mail";
import { applyProjectAddress } from "./configs";

const PageIntro = ({
  t,
}) => {
  const onApplyClick = () => {
    window.open(applyProjectAddress);
  };

  return (
    <div className="flex mt-[80px] sm:mt-[42px]">
      <section className="w-[574px] sm:w-full">
        <h2 className="text-[40px] sm:text-[20px] font-bold sm:font-medium text-[#383742] mb-[10px]">{t('group.what')}</h2>
        <p className="text-[#8f8e92] text-[16px] sm:text-[14px]">{t('group.xtstarter2')}</p>
        <div className="sm:flex">
          <div className="">
            <PirmaryBtn onClick={onApplyClick} type="primary" color="#fff" className="block my-[25px] rounded-[3px] px-[50px] sm:px-[45px]">{t('group.project')}</PirmaryBtn>

            <div className="">
              <a href="https://twitter.com/xtstarter/" target="_blank" rel="noopener">
                <Twitter className="text-[#B9B9BA] hover:text-primary mr-[10px]" />
              </a>
              <a href="https://t.me/XTSTARTER/" target="_blank" rel="noopener">
                <Telegram className="text-[#B9B9BA] hover:text-primary mr-[10px]" />
              </a>
              <a href="mailto:xtstarter@xt.com/" target="_self">
                <Mail className="text-[#B9B9BA] hover:text-primary" />
              </a>
            </div>
          </div>
          <img src={currencyPng} alt="" className="ml-[27px] w-[154px] hidden sm:block" />
        </div>
      </section>
      <img src={currencyPng} alt="" className="ml-[206px] w-[309px] sm:hidden" />
    </div>
  );
};

export default observer(withT(PageIntro));
